import { useEffect, ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  syncPathname,
  ACTION_NAVIGATE_SYNC,
  NavigateSyncResponse,
} from '@tiendanube/nexo';
import nexo from '../nexoClient';

interface Props {
  children: ReactNode;
}

const NexoSyncRoute: React.FC<Props> = ({ children }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // Sync app pathname to browser URL
  useEffect(() => {
    syncPathname(nexo, pathname);
  }, [pathname]);

  // Listen for navigation from admin
  useEffect(() => {
    const unsubscribe = nexo.suscribe(
      ACTION_NAVIGATE_SYNC,
      ({ path, replace }: NavigateSyncResponse) => {
        if (replace) {
          navigate(path, { replace: true });
        } else {
          navigate(path);
        }
      }
    );
    return unsubscribe;
  }, [navigate]);

  return <>{children}</>;
};

export default NexoSyncRoute;
